import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import logo from "../../assets/logo.png";
import confirmImg from "../../assets/signin.png";

export default function ConfirmEmail() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  const navigate = useNavigate();

  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
  return (
    <div className="h-screen flex overflow-hidden">
      {/* Left Side - Image (Fixed) */}
      <div className="hidden lg:block lg:w-1/2 xl:w-[55%] relative h-screen">
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#8B52FF]/90 to-[#E05A6A]/90 z-10" />

        {/* Image */}
        <img
          src={confirmImg}
          alt="Confirm Email"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Content Overlay */}
        <div className="absolute inset-0 z-20 flex flex-col justify-between p-12 xl:p-16">
          <div></div>
          <div className="max-w-lg">
            <h2 className="text-4xl xl:text-5xl font-bold text-white mb-6 leading-tight">
              You're Almost There!
            </h2>
            <p className="text-lg text-white/80 leading-relaxed">
              Just one more step to join our community of AI trainers.
            </p>
          </div>
          <div className="flex items-center gap-8">
            <div>
              <div className="text-3xl font-bold text-white">50K+</div>
              <div className="text-white/70 text-sm">Contributors</div>
            </div>
            <div className="w-px h-12 bg-white/20" />
            <div>
              <div className="text-3xl font-bold text-white">10+</div>
              <div className="text-white/70 text-sm">Countries</div>
            </div>
            <div className="w-px h-12 bg-white/20" />
            <div>
              <div className="text-3xl font-bold text-white">$1M+</div>
              <div className="text-white/70 text-sm">Paid Out</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Content */}
      <div className="flex-1 flex flex-col bg-white h-screen">
        {/* Fixed Header */}
        <div className="flex-shrink-0 p-6 lg:p-8 border-b border-gray-100">
          <Link to={FRONTEND_URL as string}>
            <img src={logo} alt="Unimerg" className="h-9 w-auto" />
          </Link>
        </div>

        {/* Content Container */}
        <div className="flex-1 flex items-center justify-center px-6 lg:px-12 xl:px-20 py-8">
          <div className="w-full max-w-sm text-center">
            {/* Success Icon */}
            <div className="mx-auto w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-lg shadow-green-500/30 mb-8">
              <CheckCircle className="w-10 h-10 text-white" />
            </div>

            {/* Header */}
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              Check Your Email
            </h1>
            <p className="text-gray-500 leading-relaxed mb-8">
              We've sent a confirmation link to your email address. Please check
              your inbox and spam folder to verify your account.
            </p>

            {/* Email Icon Card */}
            {/* <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100 mb-8">
              <Mail className="w-12 h-12 mx-auto text-[#8B52FF] mb-4" />
              <p className="text-sm text-gray-600">
                Click the link in the email to activate your account
              </p>
            </div> */}

            {/* Back to Login Button */}
            <button
              onClick={() => navigate("/login")}
              className="w-full py-3.5 bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold rounded-xl shadow-lg shadow-[#8B52FF]/25 hover:shadow-xl hover:shadow-[#8B52FF]/30 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 flex items-center justify-center gap-2 group"
            >
              Go to Login
              <ArrowRight className="w-5 h-5 group-hover:translate-x-0.5 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
